import React from 'react';
import StaffForm from '../../Components/Staff/StaffForm';

export default function AssistantDoctorForm() {
  return (
    <StaffForm
      role="assistantDoctor"
      title="Assistant Doctor"
      returnUrl="/assistantDoctor"
    />
  );
}
